"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GridProvider = void 0;

var _gridContext = require("./context/grid-context");

var _jsxRuntime = require("react/jsx-runtime");

/**
 * Small simple wrapper for the `GridContext.Provider`
 */
var GridProvider = function GridProvider(_ref) {
  var children = _ref.children,
      _ref$config = _ref.config,
      config = _ref$config === void 0 ? {} : _ref$config;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_gridContext.GridContext.Provider, {
    value: config,
    children: children
  });
};

exports.GridProvider = GridProvider;